import { CSSProperties } from 'react';

import './Avatar.styl';

export type AvatarSize = 22 | 28 | 30 | 36 | 44 | 72;

type Props = {
  initials: string;
  color: string;
  name?: string;
  size?: AvatarSize;
  square?: boolean;
  dark?: boolean;
  className?: string;
  /** Picture to show instead of the initials. */
  src?: string | null;
};

/** Tint background + ink text, or dark ink background when `dark`. */
export function Avatar({ initials, color, name, size = 28, square = false, dark = false, className, src }: Props) {
  const classes = ['a-avatar', `a-avatar--${size}`];
  if (square) classes.push('a-avatar--square');
  if (dark) classes.push('a-avatar--dark');
  if (className) classes.push(className);
  if (src) classes.push('a-avatar--image');
  const style = { '--avatar-tint': color } as CSSProperties;
  return (
    <span className={classes.join(' ')} style={style} aria-label={name} role={name ? 'img' : undefined} title={name}>
      {src ? <img className="a-avatar__img" src={src} alt="" loading="lazy" decoding="async" /> : initials}
    </span>
  );
}
